import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs/Rx';
import { RegulationsService } from './regulations.service';
import { ApiService } from './api.service';

@Injectable()
export class RegulationGuard {

  constructor(
    private regService: RegulationsService,
    private apiService: ApiService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): any {
    return this.regService.checkRegulations().toPromise().then((accept) => {
      if (accept) {
        this.router.navigateByUrl('/accepting-regulations');
        return Promise.resolve(!this.regService.needAccepting());
      }
      return Promise.resolve(true);
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/regulations.guard.ts